export const API_HOST = "https://norma.nomoreparties.space"
